<template>
  <div class="add-license-id-dailog dialog col-block">
    <div class="title-container">
      <div class="main-title small">{{ $t('DIALOG.addLicenseID.___title') }}</div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <customForm
      :init="licenseData"
      :alerts="alerts"
      :forms="formOptions['field1']"
      @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
    >
      <template slot="CREATE_BUTTON" slot-scope="props">
        <div :name="props" class="col-block flex-start">
          <button type="button" class="main-button circle-button auto-button" @click="e => createLicenseID()">
            <span>{{ $t('COMMON.button.___create') }}</span>
          </button>
        </div>
      </template>
    </customForm>
    <div :style="{ height: '15px' }"></div>
    <div class="row-block" :style="{ padding: '0 10px', 'box-sizing': 'border-box' }">
      <div :style="{ flex: 1, height: '1px', background: '#003679' }"></div>
      <div :style="{ width: '20px' }"></div>
      <div :style="{ 'color': '#003679', 'font-size': '1rem', 'font-weight': 'bold' }">{{ $t('DIALOG.addLicenseID.___or') }}</div>
      <div :style="{ width: '20px' }"></div>
      <div :style="{ flex: 1, height: '1px', background: '#003679' }"></div>
    </div>
    <div :style="{ height: '15px' }"></div>
    <customForm
      :init="licenseData"
      :alerts="alerts"
      :forms="formOptions['field2']"
      @change="(result, validate, errors) => formOnChange('field2', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateImportLicenseID() : ''">
        <span>{{ $t('COMMON.button.___add') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { postGenerateLicenseID, putGenerateLicenseID } from '../../api'
import customForm from '../../components/tool/customForm'
import toastMethods from '../../mixins/toastMethods'

export default {
  components: {
    customForm
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      licenseData: {},
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: this.$t('DIALOG.addLicenseID.form.title.___create'),
            value: 'CREATE_BUTTON'
          }
        ],
        field2: [
          {
            title: this.$t('DIALOG.addLicenseID.form.title.___import'),
            value: 'license_id',
            type: 'input',
            placeholder: () => this.$t('DIALOG.addLicenseID.form.placeholder.___import'),
            validate: 'required'
          }
        ]
      }
    }
  },
  methods: {
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.licenseData)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateImportLicenseID () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.importLicenseID()
      }
      this.onSubmit = false
    },
    async importLicenseID () {
      try {
        let config = this.$ls.get('userInfo')
        let licenseID = this.result.license_id
        let response = await putGenerateLicenseID(licenseID, config)
        this.addToast('success', response.data.result.message)
        this.$emit('changeModal', {}, true)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    },
    async createLicenseID () {
      this.onSubmit = true
      try {
        let config = this.$ls.get('userInfo')
        let response = await postGenerateLicenseID(config)
        this.addToast('success', response.data.result.message)
        this.$emit('changeModal', {}, true)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
      this.onSubmit = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/addLicenseID.vue